export default __webpack_public_path__ + "static/media/empty_folder_drop.b1c2c80c.svg";